export function normalizeCardMedia(items) {
  if (!Array.isArray(items)) return [];
  return items.map((item) => typeof item === "string"
    ? { src: item, storagePath: "", type: "image", alt: "" }
    : {
        src: item?.src || item?.storageURL || "",
        storagePath: item?.storagePath || "",
        type: item?.type === "video" ? "video" : "image",
        alt: item?.alt || "",
      }).filter((item) => item.src || item.storagePath);
}

export function clampImageIndex(index, length) {
  return Math.max(0, Math.min(Number.isFinite(index) ? Math.trunc(index) : 0, Math.max(0, length - 1)));
}

export async function fetchProtectedImage({ storagePath, user, signal, fetchImpl = fetch }) {
  const token = await user?.getIdToken?.();
  const response = await fetchImpl("/api/discussion-media", {
    method: "POST",
    signal,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ storagePath }),
  });
  if (!response.ok) throw new Error(`Media request failed (${response.status})`);
  return response.blob();
}

// Preserve Next.js history state and keep the route/query unchanged. Back dismisses
// only this viewer entry; it must not navigate the feed or discussion underneath.
export function createImageViewerHistory({ history, events, onClose }) {
  const previous = history.state;
  const id = `image-viewer-${Math.random().toString(36).slice(2)}`;
  let closing = false;
  history.pushState({ ...previous, sproutlyImageViewer: id }, "");
  const onPop = () => {
    if (history.state?.sproutlyImageViewer !== id) onClose();
  };
  events.addEventListener("popstate", onPop);
  return {
    close() {
      if (closing) return;
      closing = true;
      if (history.state?.sproutlyImageViewer === id) history.back();
      else onClose();
    },
    dispose() {
      events.removeEventListener("popstate", onPop);
      if (history.state?.sproutlyImageViewer === id) history.replaceState(previous, "");
    },
  };
}
